import * as Utils from "./utils";

class SearchUtils {
    constructor() {}
    
    pushRecentSearches(navSearch) {
        Utils.pushRecentSearches(navSearch);
    }
}

export default SearchUtils;